import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Pagination } from 'antd';
import plus from '../dist/webImages/plus.svg';
import useGet from '../customHooks/useGet';
import SkeletonGuidanceCard from './SkeletonGuidanceCard';
import GuidanceCard from './GuidanceCard';

const PAGE_SIZE = 10;

const canAccessGuideAction = (permission, action) =>
  permission?.Guidance?.includes(action) ||
  permission?.Guide?.includes(action);

const Guidance = ({ permission }) => {
  const [datas, setDatas] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationn, setPaginationn] = useState({});
  const [resget, apiMethodGet] = useGet();

  useEffect(() => {
    apiMethodGet(`guidance?page=${currentPage}&per_page=${PAGE_SIZE}`);
  }, [currentPage]);

  useEffect(() => {
    if (!resget?.isLoading && resget?.data) {
      const responseData = resget?.data?.data;
      const list = Array.isArray(responseData)
        ? responseData
        : Array.isArray(responseData?.data)
          ? responseData?.data
          : [];
      const paginationData = resget?.data?.pagination ?? responseData?.pagination ?? {};

      setDatas(list);
      setPaginationn(paginationData);
    }
  }, [resget?.data, resget?.isLoading]);

  return (
    <div className='Promotions pr-10 max-lg:pr-6'>
      <div className="TeamPageTop flex justify-between items-center">
        <h6 className='text-[1rem] mb-2 bookingSectionh relative px-3 font-Mluvka capitalize'>
          Guidance
        </h6>
        {canAccessGuideAction(permission, 'Guide Add') && (
          <Link
            to="/guidance/create"
            className='bg-[#d9dcf8] py-3 px-6 rounded-full flex items-center gap-2 cursor-pointer'
          >
            <img src={plus} alt="plus" style={{ filter: "brightness(100)" }} />
            <span className='font-MluvkaBold text-white capitalize'>Create Guidance</span>
          </Link>
        )}
      </div>

      <div className="NewsPageGrid mt-4 bg-[#EFF4FD] rounded-3xl p-6 grid grid-cols-1 gap-3 max-lg:p-3">
        {resget.isLoading
          ? Array.from({ length: 6 }).map((_, index) => (
              <React.Fragment key={index}>
                <SkeletonGuidanceCard />
              </React.Fragment>
            ))
          : datas.map((item) => (
              <React.Fragment key={item?.id}>
                <GuidanceCard
                  permission={permission}
                  data={item}
                  alldata={datas}
                  deleted={setDatas}
                />
              </React.Fragment>
            ))}
      </div>

      <div className='mt-4'>
        <Pagination
          current={currentPage}
          onChange={setCurrentPage}
          total={paginationn?.total ?? datas?.length ?? 0}
          pageSize={paginationn?.per_page ?? PAGE_SIZE}
        />
      </div>
    </div>
  );
};

export default Guidance;
